export default __webpack_public_path__ + "static/media/1638.c5c389c9.png";